import { CounterAPI } from "../counter-js-master/src/counterAPI.ts";

export default class VisitCountManager {
    constructor() {
        this.counter = new CounterAPI();
    }

    async getTotalVisits() {
        const result = await this.counter.get("supportandhelpeveryoneinneed", "official");
        return result.Count ?? "There was an error.";
    }

    async incTotalVisits() {
        const result = await this.counter.up("supportandhelpeveryoneinneed", "official");
        if (result.Count) {
            this.totalVisits = result.Count;
            console.log("Total visits: " + this.totalVisits);
            return this.totalVisits;
        }
        else {
            console.log("There was an error with setting the visit count.");
        }
    }
}